import { toast } from "sonner";
import { T, F } from "@/lib/bricks";
import { shortHash, trailRows, fingerprintRows, flattenedLine } from "@/lib/esignAudit";

// Fingerprints and the audit trail for one envelope: quiet ledger rows, mono figures.
export default function EnvelopeAudit({ env, p }) {
  const prints = fingerprintRows(env);
  const rows = trailRows(env.audit);
  const flat = env.status === 'completed' ? flattenedLine(env.signed_fields_flattened) : '';
  if (!prints.length && !rows.length && !flat) return null;

  const label = { fontSize: 12, color: p.ink3, margin: '6px 0 2px' };
  const mono = { fontFamily: F.mono, fontVariantNumeric: 'tabular-nums', fontSize: 12 };
  const line = { borderTop: `1px solid ${p.hair}`, padding: '8px 0', fontSize: 13 };
  const copy = (hash) => (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(hash).then(() => toast.success("Fingerprint copied")).catch(() => toast.error("Could not copy"));
  };

  return (
    <div data-testid={`envelope-audit-${env.id}`} style={{ display: 'flex', flexDirection: 'column' }}>
      {(prints.length > 0 || flat) && <>
        <div style={label}>Fingerprints</div>
        {prints.map(r => (
          <div key={r.key} style={{ ...line, display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', columnGap: 12, rowGap: 2 }}>
            <span style={{ flex: '0 0 150px', color: p.ink2 }}>{r.label}</span>
            <span style={{ flex: '1 1 200px', minWidth: 0, display: 'flex', justifyContent: 'space-between', gap: 12 }}>
              <span title={r.hash} style={{ ...mono, color: p.ink }}>{shortHash(r.hash)}</span>
              <button onClick={copy(r.hash)} aria-label={`Copy ${r.label}`} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: 12.5, color: p.ink3, fontFamily: F.display }}>Copy</button>
            </span>
            {r.note && <div style={{ flexBasis: '100%', fontSize: 12.5, color: T.brickDeep }}>{r.note}</div>}
          </div>
        ))}
        {flat && <div style={{ ...line, color: p.ink2 }}>{flat}</div>}
      </>}
      {rows.length > 0 && <>
        <div style={label}>Audit trail</div>
        <div role="list" aria-label="Audit trail">
          {rows.map((r, i) => (
            <div role="listitem" key={i} style={{ ...line, display: 'flex', flexWrap: 'wrap', columnGap: 12, rowGap: 2, alignItems: 'baseline' }}>
              <span style={{ ...mono, color: p.ink3, flex: '0 0 118px' }}>{r.time}</span>
              <span style={{ flex: '1 1 180px', minWidth: 0, color: p.ink }}>
                {r.event}{r.who ? <span style={{ color: p.ink3 }}>{` · ${r.who}`}</span> : null}
              </span>
              {(r.ip || r.browser) && (
                <span title={r.userAgent || undefined} style={{ flex: '1 1 220px', minWidth: 0, color: p.ink3, fontSize: 12.5 }}>
                  {r.ip && <span style={mono}>{r.ip}</span>}{r.ip && r.browser ? ' · ' : ''}{r.browser}
                </span>
              )}
            </div>
          ))}
        </div>
      </>}
    </div>
  );
}
